import { atom } from 'jotai'
import { BaseErrorResponse } from 'types/beneficiaries'

export const capabilitiesErrorAtom = atom<BaseErrorResponse | undefined>()
